module.exports = __webpack_public_path__ + "assets/media/mp.20cbc4d2.mp3";